const oneSuspect = "2 3 4 - 3 2 2 " //Dorris
const twoSuspect = "7 7 2 - 2 9 1 " //Logan
const threeSuspect = "1 1 2 - 3 9 2 " //Bruce
const fourSuspect = "0 5 0 - 4 9 5 " //Nigel
const fiveSuspect = "7 4 9 - 1 2 6 " //Mary
const sixSuspect = "2 2 2 - 1 1 8 " //Tara
const sevenSuspect = "5 1 5 - 8 5 4 " //Harriette

const keypadAnswerData = [
    {
        referenceNumbers: [oneSuspect, twoSuspect, threeSuspect, fourSuspect, fiveSuspect, sixSuspect, sevenSuspect]
    },
    {
        correctAnswer: oneSuspect,
        eliminatedAnswers: [],
        nextPassword: "Indigo",
        keypadLocked: true,
        codeText: "Solve the puzzles"
    },
    {
        correctAnswer: twoSuspect,
        eliminatedAnswers: [oneSuspect],
        nextPassword: "Anvil",
        keypadLocked: true,
        codeText: "Enter the correct values",
        unlockPassword: "8573"
    },
    {
        correctAnswer: threeSuspect,
        eliminatedAnswers: [oneSuspect, twoSuspect],
        nextPassword: "Rogue",
        keypadLocked: true,
        codeText: "Enter the innocent suspect's fingerprint analysis code",
        unlockPassword: "7a87qr9j5"
    },
    {
        correctAnswer: fourSuspect,
        eliminatedAnswers: [oneSuspect, twoSuspect, threeSuspect],
        nextPassword: "Justice",
        keypadLocked: true,
        codeText: "Solve the puzzles"
    },
]
    
export default keypadAnswerData